<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Filial"
                @click.stop="atualizarFilial()"
            ></i>
        </span>
    </div>
</template>

<script>

export default {
    props: {
        filialId: {
            type: String
        }
    },

    methods: {
        atualizarFilial() {
            this.$router.push({
                name: `${this.$route.name}_Atualizar_Filial`,
                params: {
                    operacao: 'ATUALIZAR',
                    filialId: this.filialId
                }
            })
        },
    }
}

</script>